module.exports = __webpack_public_path__ + "static/media/image_04.ba74999b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/stories/image_04.png
// module id = 1521
// module chunks = 0